"use strict";
// automatically generated by the FlatBuffers compiler, do not modify
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BoneT = exports.Bone = void 0;
const flatbuffers = __importStar(require("flatbuffers"));
const body_part_js_1 = require("../../solarxr-protocol/datatypes/body-part.js");
const quat_js_1 = require("../../solarxr-protocol/datatypes/math/quat.js");
const vec3f_js_1 = require("../../solarxr-protocol/datatypes/math/vec3f.js");
class Bone {
    constructor() {
        this.bb = null;
        this.bb_pos = 0;
    }
    __init(i, bb) {
        this.bb_pos = i;
        this.bb = bb;
        return this;
    }
    static getRootAsBone(bb, obj) {
        return (obj || new Bone()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    static getSizePrefixedRootAsBone(bb, obj) {
        bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
        return (obj || new Bone()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    bodyPart() {
        const offset = this.bb.__offset(this.bb_pos, 4);
        return offset ? this.bb.readUint8(this.bb_pos + offset) : body_part_js_1.BodyPart.NONE;
    }
    /**
     * The global rotation of the bone.
     *
     * Note that the identity rotation is where a bone's tail is towards -y (assuming
     * the head of the bone is the origin)
     */
    rotationG(obj) {
        const offset = this.bb.__offset(this.bb_pos, 6);
        return offset ? (obj || new quat_js_1.Quat()).__init(this.bb_pos + offset, this.bb) : null;
    }
    boneLength() {
        const offset = this.bb.__offset(this.bb_pos, 8);
        return offset ? this.bb.readFloat32(this.bb_pos + offset) : 0.0;
    }
    /**
     * The global position of the head of this bone.
     *
     * The head of a bone is joint/node of the bone touching the parent bone. The
     * parent is defined as the bone closer to the HMD.
     */
    headPositionG(obj) {
        const offset = this.bb.__offset(this.bb_pos, 10);
        return offset ? (obj || new vec3f_js_1.Vec3f()).__init(this.bb_pos + offset, this.bb) : null;
    }
    static startBone(builder) {
        builder.startObject(4);
    }
    static addBodyPart(builder, bodyPart) {
        builder.addFieldInt8(0, bodyPart, body_part_js_1.BodyPart.NONE);
    }
    static addRotationG(builder, rotationGOffset) {
        builder.addFieldStruct(1, rotationGOffset, 0);
    }
    static addBoneLength(builder, boneLength) {
        builder.addFieldFloat32(2, boneLength, 0.0);
    }
    static addHeadPositionG(builder, headPositionGOffset) {
        builder.addFieldStruct(3, headPositionGOffset, 0);
    }
    static endBone(builder) {
        const offset = builder.endObject();
        return offset;
    }
    unpack() {
        return new BoneT(this.bodyPart(), (this.rotationG() !== null ? this.rotationG().unpack() : null), this.boneLength(), (this.headPositionG() !== null ? this.headPositionG().unpack() : null));
    }
    unpackTo(_o) {
        _o.bodyPart = this.bodyPart();
        _o.rotationG = (this.rotationG() !== null ? this.rotationG().unpack() : null);
        _o.boneLength = this.boneLength();
        _o.headPositionG = (this.headPositionG() !== null ? this.headPositionG().unpack() : null);
    }
}
exports.Bone = Bone;
class BoneT {
    constructor(bodyPart = body_part_js_1.BodyPart.NONE, rotationG = null, boneLength = 0.0, headPositionG = null) {
        this.bodyPart = bodyPart;
        this.rotationG = rotationG;
        this.boneLength = boneLength;
        this.headPositionG = headPositionG;
    }
    pack(builder) {
        Bone.startBone(builder);
        Bone.addBodyPart(builder, this.bodyPart);
        Bone.addRotationG(builder, (this.rotationG !== null ? this.rotationG.pack(builder) : 0));
        Bone.addBoneLength(builder, this.boneLength);
        Bone.addHeadPositionG(builder, (this.headPositionG !== null ? this.headPositionG.pack(builder) : 0));
        return Bone.endBone(builder);
    }
}
exports.BoneT = BoneT;
